import postWithToken from './base/post-with-token'

const customerShareVerifyCode = (customerId, { email, shareCode }) => {
    return postWithToken(`/customer/${customerId}/share/verify-code`)({
        email,
        shareCode,
    })
}

export default customerShareVerifyCode

